import { lazy, Suspense } from 'react';

import { type RouteComponentProps } from 'react-router'

import { type PayCardStatusV2 } from '@webapp/models/enums'
import { type Enum } from '@webapp/utils'

export const SpendingCardManagementListPageTabs = {
  ACTIVE: 'active',
  REQUESTED: 'requested',
  PENDING: 'pending',
  INACTIVE: 'inactive',
  CANCELED: 'canceled',
} as const

export type SpendingCardManagementListPageTabStatus = Enum<
  typeof SpendingCardManagementListPageTabs
>

export interface SpendingCardManagementListPageParams {
  tab: SpendingCardManagementListPageTabStatus
}

const SpendingCardManagementListViewChunk = lazy(() =>
  import('../containers/SpendingCardManagementListView').then(
    ({ SpendingCardManagementListView }) => ({
      default: SpendingCardManagementListView,
    })
  )
)

export const SpendingCardManagementListPage = (
  props: RouteComponentProps<{ status: PayCardStatusV2 }>
) => {
  return (
    <Suspense fallback={null}>
      <SpendingCardManagementListViewChunk {...props} />
    </Suspense>
  );
}
